// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { styled } from "@mui/material/styles";
import { CustomTabPanel } from "../CustomTabPanel";
import Tabs from "@mui/material/Tabs";
export var SidebarScreenStyles = {
    CustomTabPanel: styled(CustomTabPanel)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        padding: 10px;\n    "], ["\n        padding: 10px;\n    "]))),
    Tabs: styled(Tabs)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n        margin-bottom: 10px;\n    "], ["\n        border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n        margin-bottom: 10px;\n    "]))),
};
var templateObject_1, templateObject_2;
